import { useEffect, useState, ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

interface Props {
  children: ReactNode
}

/**
 * Wraps authenticated pages. Calls GET /api/auth/me — redirects to /login if 401.
 * SUPPORT avec tenantId='' → redirige vers /support/tenant-picker.
 */
export function AuthGuard({ children }: Props) {
  const navigate = useNavigate()
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    fetch('/api/auth/me', { credentials: 'include' })
      .then(async (res) => {
        if (res.status === 401) {
          navigate('/login', { replace: true })
          return
        }
        const user = await res.json().catch(() => null)
        // SUPPORT sans tenant → forcer le picker
        if (user?.role === 'SUPPORT' && !user?.tenantId) {
          navigate('/support/tenant-picker', { replace: true })
          return
        }
        setChecked(true)
      })
      .catch(() => navigate('/login', { replace: true }))
  }, [navigate])

  if (!checked) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-[var(--color-primary)] border-t-transparent" />
      </div>
    )
  }

  return <>{children}</>
}
